(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cyber-category-nav"] && !Shopify.designMode) return;
  try {
    
  (() => {
    let lastUrl = '';
    const update = () => {
      const navs = document.querySelectorAll('[data-cyber-nav]');
      if (!navs.length) return;
      if (lastUrl === location.href) return;
      lastUrl = location.href;
      const current = new URL(location.href);
      navs.forEach(nav => {
        const base = nav.dataset.collectionUrl.replace(/\/$/, '');
        const tag = decodeURIComponent(current.pathname.slice(base.length)).replace(/^\/+|\/+$/g, '');
        const vendors = current.searchParams.getAll('filter.p.vendor');
        nav.querySelectorAll('[data-cyber-tag]').forEach(link => {
          const active = tag === link.dataset.cyberTag && (!link.dataset.cyberVendor || link.dataset.cyberVendor.split(',').some(vendor => vendors.includes(vendor.trim())));
          link.classList.toggle('is-active', active);
          if (active) link.setAttribute('aria-current', 'page'); else link.removeAttribute('aria-current');
        });
        const all = nav.querySelector('[data-cyber-all]');
        const active = !tag && !vendors.length;
        all.classList.toggle('is-active', active);
        if (active) all.setAttribute('aria-current', 'page'); else all.removeAttribute('aria-current');
      });
    };
    update();
    window.addEventListener('popstate', () => { lastUrl = ''; update(); });
    document.addEventListener('shopify:section:load', () => { lastUrl = ''; update(); });
    const results = document.querySelector('results-list');
    if (results) new MutationObserver(update).observe(results, { childList: true, subtree: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
